import { StateCreator } from 'zustand'

interface ActivityLog {
    timestamp: number
    action: string
    module: string
    view?: string
    details?: Record<string, any>
}

export interface AnalyticsSlice {
    activityLogs: ActivityLog[]
    logActivity: (log: Omit<ActivityLog, 'timestamp'>) => void
    getModuleUsage: () => Record<string, number>
    getMostUsedViews: (
        limit?: number
    ) => Array<{ viewId: string; count: number }>
}

export const createAnalyticsSlice: StateCreator<AnalyticsSlice> = (
    set,
    get
) => ({
    activityLogs: [],
    logActivity: (log) => {
        set((state) => ({
            activityLogs: [
                { ...log, timestamp: Date.now() },
                ...state.activityLogs
            ].slice(0, 1000) // Keep last 1000 activities
        }))
    },
    getModuleUsage: () => {
        const logs = get().activityLogs

        return logs.reduce(
            (acc, log) => ({
                ...acc,
                [log.module]: (acc[log.module] || 0) + 1
            }),
            {} as Record<string, number>
        )
    },
    getMostUsedViews: (limit = 5) => {
        const logs = get().activityLogs
        const viewCounts = logs.reduce(
            (acc, log) => {
                if (log.view) {
                    acc[log.view] = (acc[log.view] || 0) + 1
                }

                return acc
            },
            {} as Record<string, number>
        )

        return Object.entries(viewCounts)
            .map(([viewId, count]) => ({ viewId, count }))
            .sort((a, b) => b.count - a.count)
            .slice(0, limit)
    }
})
